import { Link, Outlet, useLocation } from 'react-router-dom';
import { pagesConfig, viewAdminDetailPages } from '../../shared/pages-config';
import { useRouteMatch } from '../../shared/useRouteMatch';
import { userPortalPagesConfig } from '../../shared/user-portal-pages-config';
import SimpleBreadcrumbsPage from '../../shared/simple-breadcrumbs-page';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import SharedTabCard from '../../shared/shared-tab-card';

export default function ViewAdminLayout() {
  const location = useLocation();

  const isUserPortal = location.pathname.includes(
    userPortalPagesConfig.userPortal.link
  );

  const routeMatch = useRouteMatch(
    isUserPortal
      ? [
          `${userPortalPagesConfig.userPortal.link}/${pagesConfig.viewAdmin.link}/${pagesConfig.marketingManager.link}`,
          `${userPortalPagesConfig.userPortal.link}/${pagesConfig.viewAdmin.link}/${pagesConfig.errorTesting.link}`,
          `${userPortalPagesConfig.userPortal.link}/${pagesConfig.viewAdmin.link}/${pagesConfig.adminLabs.link}`,
          `${userPortalPagesConfig.userPortal.link}/${pagesConfig.viewAdmin.link}/${pagesConfig.uiSandbox.link}`,
        ]
      : [
          `${pagesConfig.viewAdmin.link}/${pagesConfig.marketingManager.link}`,
          `${pagesConfig.viewAdmin.link}/${pagesConfig.errorTesting.link}`,
          `${pagesConfig.viewAdmin.link}/${pagesConfig.adminLabs.link}`,
          `${pagesConfig.viewAdmin.link}/${pagesConfig.uiSandbox.link}`,
        ]
  );
  const currentTab =
    routeMatch?.pattern?.path ?? `${pagesConfig.marketingManager.link}`;

  const viewAdminBreadcrumbMap: Record<string, string> = {
    [pagesConfig.marketingManager.link]: pagesConfig.marketingManager.name,
    [pagesConfig.errorTesting.link]: pagesConfig.errorTesting.name,
    [pagesConfig.adminLabs.link]: pagesConfig.adminLabs.name,
    [pagesConfig.uiSandbox.link]: pagesConfig.uiSandbox.name,
  };

  const tabValue = currentTab.split('/').pop();

  const activeViewAdminBreadcrumb = tabValue
    ? viewAdminBreadcrumbMap[tabValue]
    : undefined;

  return (
    <SimpleBreadcrumbsPage
      breadcrumbs={[
        { label: pagesConfig.viewAdmin.name },
        ...(activeViewAdminBreadcrumb
          ? [{ label: activeViewAdminBreadcrumb }]
          : []),
      ]}
      bookmarkKey={pagesConfig.viewAdmin.value}
      topContent={
        <SharedTabCard>
          <Tabs
            value={currentTab.split('/').pop()}
            variant="scrollable"
            allowScrollButtonsMobile
            scrollButtons={false}
            sx={{
              mx: 1,
              '& .MuiTabs-flexContainer': {
                marginTop: '6px',
              },
              '.MuiTabs-scrollButtons.Mui-disabled': {
                opacity: 0.3,
              },
            }}
          >
            {viewAdminDetailPages.map((page) => {
              return (
                <Tab
                  key={page.name}
                  value={page.link}
                  component={Link}
                  to={page.link}
                  label={page.name}
                  icon={<page.icon />}
                  iconPosition="start"
                  sx={{
                    minHeight: '40px',
                    height: '40px',
                    width: 'fit-content',
                  }}
                />
              );
            })}
          </Tabs>
        </SharedTabCard>
      }
      heightOfTopContent={isUserPortal ? 116 : 58}
      isSubTabs
    >
      <Outlet />
    </SimpleBreadcrumbsPage>
  );
}
